module.exports = __webpack_public_path__ + "img/Event4.a9a8d802.jpg";